module.exports = __webpack_public_path__ + "img/empty-temp-introduce-5.ef891415.jpg";